import { appMethod as app, appInstance } from '@utils/app';
import * as customEvent from '@utils/customEvent';
import { getCurrentPageQueryParams, convertLineStyleData, convertTagStyle, convertHtmlTag } from '@utils/tools';
import OfficialPage from '../OfficialPage';

import './videoActivityDetail.less'

export default class VideoActivityDetail extends OfficialPage {
  state = {
    activityId: '',
    activityInfo: {},
    shopInfo: {},
    franchiseeId: '',
    hasReward: false,
    videoSrc: '',
    showRewardBtn: false,
    hideVideo: true,
    fromClickEvent: false,
    hasAuth: false,    // 授权成功参数
    isMixVideos: false,
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let franchisee = options.sub_app_id || options.franchisee || ''
    let activityId = options.id || ''
    let hasAuth = !!options.hasAuth || false
    this.setData({
      hasAuth: hasAuth,
      franchiseeId: franchisee,
      activityId: activityId,
      fromClickEvent: !!options.fromClickEvent
    })
    this.getActivityDetail()
    let str = ``;
    // console.log(convertHtmlTag(convertTagStyle(str)));
  }
  getActivityDetail = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/GetVideoActivityByPage',
      data: {
        sub_shop_app_id: that.data.franchiseeId || '',
        id: that.data.activityId,
        in_activity: that.data.fromClickEvent ? 1 : ''
      },
      method: 'post',
      success: function(res) {
        if (!res.data.length) {
          return
        }
        
        let activityInfo = res.data[0].form_data
        let shopInfo = {}
        let newData = {}
        activityInfo.status = res.data[0].status
        let getAuthInfo = app.getStorageSync('getAuthInfo')

        if (that.data.hasAuth) {
          that.setData({
            hasReward: true,
            showRewardBtn: true
          })
          // 返回时路径会一直携带hasAuth，需根据getAuthInfo判断是否授权返回
          if (getAuthInfo) {
            app.removeStorage({key: 'getAuthInfo'})
            app.showToast({
              title: '视频发布成功！',
              icon: 'success',
              duration: 1000
            })
            setTimeout(function() {
              // 若设置了领取成功跳转页面
              let success_page_url = activityInfo.success_page_url
              if (success_page_url) {
                window.location.href = success_page_url
              }
            }, 1000)
          }
        }
        if (
          activityInfo['store'] &&
          activityInfo['store']['title'] &&
          !this.data.franchiseeId
        ) {
          let store = activityInfo['store']
          shopInfo = {
            name: store['title'],
            address: `${store.country}${store.province}${store.city}${store.district}${store.address_detail}`,
            phone: store['phone'],
            latitude: +store['latitude'] || '',
            longitude: +store['longitude'] || '',
            detailAddress: store.address_detail || ''
          }
          newData['shopInfo'] = shopInfo
        } else if (that.data.franchiseeId) {
          that.getSubShopInfo()
        }
        newData['activityInfo'] = activityInfo
        newData['activityId'] = res.data[0].id
        newData['isMixVideos'] = +activityInfo.video.mode === 1 ? true : false;
        that.setData(newData)
        if (that.data.isMixVideos) {
          that.getVideo(activityInfo['video']['struct']['top'][0]['id']);
        } else {
          that.getVideo(activityInfo['video']['struct'][0]['id'])
        }
      }
    })
  }
  getSubShopInfo = () => {
    let that = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        sub_shop_app_id: that.data.franchiseeId
      },
      success: res => {
        let info = res.data[0]
        let shopInfo = {
          name: info.name,
          address:
            info.country_region_id == 1 && info.city_name
              ? `${info.province_name}${info.city_name}${info.county_name}${info.address_detail}`
              : `${info.address_detail}${info.county_name}${info.city_name}${info.province_name}`,
          phone: info.phone,
          latitude: +info['latitude'] || '',
          longitude: +info['longitude'] || '',
          detailAddress: info.address_detail || ''
        }
        that.setData({
          shopInfo: shopInfo
        })
      }
    })
  }
  getVideo = id => {
    let that = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppVideo/GetVideoLibURL',
      data: {
        id: id
      },
      success: res => {
        that.setData({
          videoSrc: res.data
        })
      }
    })
  }
  openDouyinAuth = () => {
    let that = this
    if (app.isLogin()) {
      this.getRewards()
    } else {
      app.goLogin({
        success: function() {
          that.getRewards()
        }
      })
    }
  }
  getRewards = ticket => {
    let that = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppEcommerce/ReceiveVideoActivityGift',
      data: {
        sub_shop_app_id: that.data.franchiseeId || '',
        id: that.data.activityId,
        code: ticket || ''
      },
      success: res => {
        that.setData({
          hasReward: true,
          showRewardBtn: true
        })
        app.showToast({
          title: '视频发布成功！',
          icon: 'success',
          duration: 1000
        })
        setTimeout(function() {
          // 若设置了领取成功跳转页面
          let success_page_url = that.data.activityInfo.success_page_url
          if (success_page_url) {
            window.location.href = success_page_url
          }
        }, 1000)
      },
      fail: res => {
        console.log(res)
      },
      successStatusAbnormal: res => {
        if (res.status == 8) {
          let url = encodeURIComponent(window.location.href)
          app.setStorage({key: 'getAuthInfo', data: 1})
          window.location.href = `/index.php?r=ByteM/WebLogin&app_id=${app.getAppId()}&redirect_url=${url}`
          return false
        } else if (res.status == 1) {
          that.setData({
            showRewardBtn: true,
            hasReward: true
          })
        }
      }
    })
  }
  tapMakePhoneCall = () => {
    let that = this
    if (!that.data.shopInfo.phone) {
      app.showModal({
        content: '未设置联系方式'
      })
      return
    }
    app.makePhoneCall(that.data.shopInfo.phone)
  }
  toCouponList = () => {
    this.setData({
      hasReward: false
    })
    app.turnToPage('/pages/couponList/couponList')
  }
  playVideo = () => {
    this.setData({
      hideVideo: false
    })
  }
  videoClose = () => {
    this.setData({
      hideVideo: true
    })
  }
  toCheckRewards = e => {
    let success_page_url = this.data.activityInfo.success_page_url
    if (success_page_url) {
      window.location.href = success_page_url
    }
    return;
    // 多个奖励去奖励列表
    let rewardList = this.data.activityInfo.reward_list
    if (rewardList.length > 1) {
      app.turnToPage(
        '/pages/videoActivityReward/videoActivityReward?id=' +
          this.data.activityId +
          '&sub_app_id=' +
          this.data.franchiseeId
      )
      return
    }
    let { type, value } = rewardList[0]
    let path = ''
    switch (type.toString()) {
      case '1':
        path = '/pages/couponDetail/couponDetail?detail=' + value // 优惠券列表
        break
      case '2':
        path = '/pages/myIntegral/myIntegral' // 积分详情
        break
      case '3':
        path = '/pages/balance/balance' // 储值
        break
      case '4':
        path = '/pages/vipCardList/vipCardList' // 会员卡列表
        break
      case '5':
        path = '/pages/vipBenefits/vipBenefits?id=' + this.data.activityId // 会员权益
        break
      case '6':
        path = '/pages/collectStars/collectStars' // 集集乐
        break
      case '7':
        path = '/pages/luckyWheelDetail/luckyWheelDetail' // 大转盘
        break
      case '8':
        path = '/pages/scratch/scratch' // 刮刮乐
        break
      case '9':
        path = '/pages/goldenEggs/goldenEggs' //砸金蛋
        break
    }
    if (this.data.franchiseeId) {
      if (/\?/.test(path)) {
        path = path + '&franchisee=' + this.data.franchiseeId
      } else {
        path = path + '?franchisee=' + this.data.franchiseeId
      }
    }
    app.turnToPage(path)
  }
  toLocation = () => {
    let { latitude, longitude, address, detailAddress } = this.data.shopInfo
    if (latitude) {
      app.openLocation({
        latitude,
        longitude,
        scale: 18,
        name: detailAddress || address,
        address,
        fail(res) {
          app.showModal({content: res});
        }
      })
    }
  }

  render() {
    const {
      showGetUserInfo,
      activityInfo,
      hideVideo,
      shopInfo,
      wxParseDescription,
      hasReward,
      videoSrc,
      isMixVideos,
    } = this.state
    return (
      <React.Fragment>
        <div>
          <div>
            {activityInfo.status == 1 ? (
              <div>
                <div className="phone-banner">
                  <div className="video-image">
                    {
                      !isMixVideos ? (
                        <img
                          src={
                            activityInfo && activityInfo.video && (activityInfo.video.struct[0].preview_img ||
                              activityInfo.video.struct[0].preview_img_default)
                          }
                          mode="aspectFill"
                          hidden={!hideVideo}
                        />
                      ) : (
                        <img
                          src={activityInfo.video.cover}
                          mode="aspectFill"
                          hidden={!hideVideo}
                        />
                      )
                    }
                    <div className="tiktok-video-play" onClick={this.playVideo}>
                      <div className="play-btn">
                        <div className="icon-play ico-moon"></div>
                      </div>
                    </div>
                  </div>
                  <div className="shop-info">
                    <div>
                      <div>{shopInfo.name || '店铺名称'}</div>
                      <div onClick={this.toLocation}>{shopInfo.address || '店铺地址'}</div>
                    </div>
                    <img
                      src="http://cdn.zhichiwangluo.com/zhichi_frontend/static/management/assets/img/tiktok-video/phone.png"
                      onClick={this.tapMakePhoneCall}
                    />
                  </div>
                </div>
                <div className="step">
                  <div className="step-title">活动步骤</div>
                  <img src="http://cdn.zhichiwangluo.com/zhichi_frontend/static/management/assets/img/tiktok-video/tiktok-activity-step.png"></img>
                </div>
                <div className="phone-desc">
                  <div className="phone-desc-title">活动说明</div>
                  <div className="phone-desc-editor">
                    <div className="goods-details rich-text" dangerouslySetInnerHTML={{ __html: activityInfo.desc && activityInfo.desc.replace(/href=".*?"/g, '') }}></div>
                  </div>
                </div>
                <div className="reward-bot">
                  {hasReward ? (
                    <div
                    className="reward-btn"
                    onClick={this.toCheckRewards}>
                    已领取奖励, 去查看
                   </div>
                  ) : (
                    <div
                    className="reward-btn"
                    onClick={this.openDouyinAuth}>
                    发视频领奖品
                  </div>
                  )}   
                </div>
              </div>
            ) : (
              <div className="attention-none">
                <img
                  src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/order-null.png"
                  alt="图片"
                />
                <div className="tips">当前暂无活动</div>
              </div>
            )}
          </div>
          {!hideVideo &&
            <div className="video-wrap">
              <video
                src={videoSrc}
                controls
                autoPlay={true}
                poster={
                  !isMixVideos ? (activityInfo && activityInfo.video && (activityInfo.video.struct[0].preview_img ||
                    activityInfo.video.struct[0].preview_img_default)) : (activityInfo.video.cover)
                }
              ></video>
              <div
                className="videoPlay-close icon-closes ico-moon"
                onClick={this.videoClose}
              ></div>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/video-activity-detail/videoActivityDetail.jsx